import Axios from 'axios'

const axios = Axios.create()

export const httpGet = ({ url, config }) => axios.get(url, config)
export const httpPost = ({ url, config, data }) => axios.post(url, data, config)
export const httpPut = ({ url, config, data }) => axios.put(url, data, config)
export const httpDelete = ({ url, config }) => axios.delete(url, config)
export const httpPatch = ({ url, config, data }) => axios.patch(url, data, config)

export const ejectAuthInterceptor = () => {
  axios.defaults.headers.common = undefined
}
